"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = PromoBanner;
var _react = _interopRequireDefault(require("react"));
var _react2 = require("@linaria/react");
var _text = _interopRequireDefault(require("@ux/text"));
var _section = _interopRequireDefault(require("@site/pattern-library-core/section"));
var _intents = _interopRequireWildcard(require("@site/pattern-library-utils/intents"));
var _patternLibraryUtils = require("@site/pattern-library-utils");
var _index = _interopRequireDefault(require("../../../elements/other/actions/index"));
var _icon = require("@site/pattern-library-utils/icon");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
/* eslint-disable react/prop-types */
/* eslint-disable react/jsx-pascal-case */

const VARIANTS = {
  stroke: 'stroke',
  solid: 'solid'
};
const StyledSection = /*#__PURE__*/(0, _react2.styled)(_section.default)({
  name: "StyledSection",
  class: "pl-szabbxh"
});
const ImageAsset = /*#__PURE__*/(0, _react2.styled)("img")({
  name: "ImageAsset",
  class: "pl-il9qrbb"
});
const LogoAsset = /*#__PURE__*/(0, _react2.styled)("img")({
  name: "LogoAsset",
  class: "pl-l1kkruxu"
});
const Inner = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "Inner",
  class: "pl-ieewywz",
  vars: {
    "ieewywz-0": [({
      variant
    }) => variant === VARIANTS.stroke ? _intents.default.ux.box.backgroundColor : _intents.default.ux.boxLowContrast.backgroundColor],
    "ieewywz-1": [({
      variant
    }) => variant === VARIANTS.stroke ? `${_intents.default.ux.box.borderWidth} solid ${_intents.default.ux.box.borderColor}` : 'none']
  }
});
const Divider = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "Divider",
  class: "pl-d1lg9tr3"
});
const EndAlignedContent = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "EndAlignedContent",
  class: "pl-e1ucm13"
});
function shouldShowDivider(a = [], b = []) {
  return a.some(Boolean) && b.some(Boolean);
}
const getIconAsset = icon => icon && /*#__PURE__*/_react.default.createElement(_icon.Icon, {
  name: icon
});
const getImageAsset = image => image?.url && /*#__PURE__*/_react.default.createElement(ImageAsset, {
  src: image.url,
  width: image.width,
  height: image.height,
  alt: image.altText,
  loading: "lazy"
});
const getLogoAsset = logo => logo?.url && /*#__PURE__*/_react.default.createElement(LogoAsset, {
  src: logo.url,
  width: logo.width,
  height: logo.height,
  alt: logo.altText,
  loading: "lazy"
});

/**
 * Promo Banner Component
 * @module PromoBanner
 *
 * @param {Object} props React props
 * @param {string} props.id The component's id
 * @param {React.ReactNode} props.tag Tag Element
 * @param {Object} props.logo Logo properties
 * @param {string} props.heading Heading text
 * @param {string} props.description Description text
 * @param {Object} props.cta Call to action button props
 * @param {string} props.trackingName The component's tracking name
 * @param {string} props.partial The component's partial
 * @param {string} props.variant The component's variant
 * @param {string} props.verticalMargin The component's vertical margin
 * @param {string} props.verticalPadding The component's vertical padding
 * @param {string} props.horizontalPadding The component's horizontal padding
 * @returns {React.ReactElement} Promo Banner Component
 * @public
 */
function PromoBanner({
  id,
  tag,
  icon,
  logo,
  image,
  heading,
  description,
  cta,
  trackingName,
  partial,
  backgroundColor,
  variant = 'stroke'
}) {
  const showDivider = shouldShowDivider([tag, logo?.url], [heading, description, cta]);
  if (![tag, logo?.url, heading, description, cta].some(Boolean)) {
    return null;
  }
  return /*#__PURE__*/_react.default.createElement(StyledSection, {
    id: id,
    dataCy: "promo-banner",
    _name: trackingName,
    verticalMargin: "none",
    verticalPadding: "small",
    padding: "large",
    backgroundColor: (0, _intents.getBackgroundColor)(backgroundColor)
  }, /*#__PURE__*/_react.default.createElement(Inner, {
    variant: variant,
    "data-partial": partial
  }, tag, getIconAsset(icon) || getImageAsset(image) || getLogoAsset(logo), showDivider ? /*#__PURE__*/_react.default.createElement(Divider, {
    "data-testid": "divider"
  }) : null, /*#__PURE__*/_react.default.createElement(EndAlignedContent, null, /*#__PURE__*/_react.default.createElement("div", {
    className: "text-block"
  }, /*#__PURE__*/_react.default.createElement(_text.default.div, {
    text: heading,
    as: "title"
  }), /*#__PURE__*/_react.default.createElement(_text.default.div, {
    text: description,
    as: "caption"
  })), cta ? /*#__PURE__*/_react.default.createElement(_index.default, {
    actionsLayout: "button-set",
    ctas: [cta]
  }) : null)));
}